module.exports = __webpack_public_path__ + "static/media/testCustomerOrder_homepage.9d431abd.png";